<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <router-link to="/admin/exams/add_exam" class="btn add">
              <i class="fas fa-plus ms-1"></i>
              إضافة اختبار جديد
            </router-link>

            <div class="dropdown sorting">
              <button
                class="btn add me-2 dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fas fa-filter ms-1"></i>
                ترتيب {{ this.currentView }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li class="dropdown-item" @click="sortByCreateDate">
                  ترتيب حسب التاريخ
                </li>
                <li class="dropdown-item" @click="sortByName">
                  ترتيب حسب الاسم
                </li>
              </ul>
            </div>
            <!-- Filter -->
            <button
              class="btn me-2 add"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
            >
              <i class="fas fa-filter ms-1"></i>
              فلتر
            </button>
            <div
              class="modal fade"
              tabindex="-1"
              id="filterModal"
              aria-labelledby="filterModalLabel"
              data-bs-backdrop="static"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <form @submit.prevent="filteredSelectData($event)">
                    <div class="modal-header">
                      <h5 class="modal-title">اعادة تصنيف</h5>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <!-- Add Categories Select -->
                      <div class="categories__select">
                        <div
                          class="categories__select__data"
                          v-show="this.categories.length > 0"
                        >
                          <div class="form-group">
                            <label>التصنيف</label>
                            <select
                              class="form-select form-control mt-2"
                              aria-label="Default select "
                              @change="onSelectMainCategory($event)"
                            >
                              <option selected disabled value="">
                                اختار التصنيف
                              </option>
                              <option
                                v-for="category in this.Maincategories"
                                :key="category.category_id"
                                :value="category.title"
                              >
                                {{ category.title }}
                              </option>
                            </select>
                          </div>
                          <Transition name="scale" mode="out-in">
                            <div
                              class="form-group"
                              v-if="this.subSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                id="subCategory"
                                @change="onSelectSubCategory($event)"
                              >
                                <option selected disabled :value="0">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </Transition>
                          <Transition name="scale" mode="out-in">
                            <div
                              class="form-group"
                              v-if="this.subSubSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                @change="onSelectSubSubCategory($event)"
                              >
                                <option selected disabled value="">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subSubSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </Transition>

                          <Transition name="scale" mode="out-in">
                            <div
                              class="form-group"
                              v-if="this.subSubSubSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                @change="onSelectSubSubSubCategory($event)"
                              >
                                <option selected disabled value="">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subSubSubSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </Transition>
                        </div>
                        <div
                          v-show="this.categories.length == 0"
                          class="categories__select__noData pt-3"
                        >
                          <p>اختار التصنيف:</p>
                          <h6 class="text-center pb-3">
                            لا يوجد تصنيفات حتى الآن
                          </h6>
                        </div>
                      </div>
                      <!-- Add Categories Select -->
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn delete"
                        data-bs-dismiss="modal"
                        @click="removeFiltered()"
                      >
                        اعادة تعيين
                      </button>
                      <button type="submit" class="btn add">تنفيذ</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    @input="getDocBySeacrh"
                    v-model="searchValue"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                    required
                  />
                </div>
              </div>
            </form>

            <table v-show="this.exams.length > 0" class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">الرقم</th>
                  <th scope="col">العنوان</th>
                  <th scope="col">الدرجة النهائية</th>
                  <th scope="col">مدة الاختبار</th>
                  <th scope="col">بداية الاختبار</th>
                  <th scope="col">نهاية الاختبار</th>
                  <th style="width: 38%" scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(exam, index) in this.exams" :key="index">
                  <th scope="row">{{ index + 1 }}</th>

                  <td>{{ exam.title }}</td>
                  <td>{{ exam.degree }}</td>
                  <td>{{ exam.duration }}</td>
                  <td>{{ exam.start_date }}</td>
                  <td>{{ exam.end_date }}</td>
                  <td class="controls">
                    <router-link
                      :to="{
                        name: 'exam_students',
                        params: { id: exam.exam_id },
                      }"
                      class="btn students"
                    >
                      <img
                        class="img-invert ms-2"
                        src="@/assets/login-icon/users-solid.svg"
                        alt="Students"
                      />
                      الطلاب
                    </router-link>
                    <router-link
                      class="btn view"
                      :to="{
                        name: 'view_exam',
                        params: { id: exam.exam_id },
                      }"
                    >
                      <i class="fas fa-folder ms-1"></i>
                      عرض
                    </router-link>

                    <router-link
                      class="btn edit"
                      :to="{
                        name: 'edit_exam',
                        params: { id: exam.exam_id },
                      }"
                    >
                      <i class="fas fa-edit"></i>
                      تعديل
                    </router-link>
                    <button
                      class="btn delete"
                      @click="this.deleteSelectedExam(exam)"
                    >
                      <i class="fas fa-trash-alt ms-2"></i>
                      حذف
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-show="
                (!this.isloading && !this.exams) || this.exams.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد اختبارات حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Swal
import Swal from "sweetalert2";
// Vuex
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      isloading: false,
      firstLoad: "",
      currentView: "الاختبارات",
      exams: [],
      categories: [],
      // Search
      searchValue: "",
      // Filter
      // All Categories
      // Get Categories has Main
      Maincategories: [],
      // Loop for Categories
      selectedCategory: null,
      selectedSubCategory: null,
      selectedSubSubCategory: null,

      // Save Result loop Categories
      subSelect: [],
      subSubSelect: [],
      subSubSubSelect: [],

      // Fitler Array
      filter: [],
    };
  },
  components: {},
  methods: {
    ...mapActions("examsModule", ["fetchExams", "deleteExam"]),

    //-----------------------------------------------
    // Sort
    sortByCreateDate() {
      this.exams.sort(
        (a, b) => b.created_date.seconds - a.created_date.seconds
      );
    },
    sortByName() {
      this.exams.sort((a, b) => (a.title < b.title ? -1 : 1));
    },
    //-----------------------------------------------
    // Get Categories
    ///// Get Main Category
    onSelectMainCategory($event) {
      let title = $event.target.value;
      this.selectedCategory = this.categories.filter(
        (item) => item.title === title
      )[0];
      // Reset Choose Sub Category
      this.subSelect = [];
      this.subSubSelect = [];
      this.subSubSubSelect = [];
      this.filter = [];

      // Choose Sub Category
      if (this.selectedCategory.sub_categories.length > 0) {
        this.subSelect.push(...this.selectedCategory.sub_categories);
      }
      this.filter.push(this.selectedCategory.category_id);
      document.getElementById("subCategory").value = 0;
    },
    ///// Get Sub Category
    onSelectSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubCategory = this.subSelect.filter(
        (item) => item.title === title
      )[0];
      this.subSubSelect = [];
      this.subSubSubSelect = [];

      this.filter.splice(1, 3);
      if (this.selectedSubCategory.sub_categories.length > 0) {
        this.subSubSelect.push(...this.selectedSubCategory.sub_categories);
      }
      this.filter.push(this.selectedSubCategory.category_id);
    },
    ///// Get Sub Sub Category
    onSelectSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubCategory = this.subSubSelect.filter(
        (item) => item.title === title
      )[0];
      this.subSubSubSelect = [];
      this.filter.splice(2, 1);

      if (this.selectedSubSubCategory.sub_categories.length > 0) {
        this.subSubSubSelect.push(
          ...this.selectedSubSubCategory.sub_categories
        );
      }
      this.filter.splice(2, 1);
      this.filter.push(this.selectedSubSubCategory.category_id);
    },

    ///// Get Sub Sub  Sub Category
    onSelectSubSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubSubCategory = this.subSubSubSelect.filter(
        (item) => item.title === title
      )[0];
      this.filter.splice(3, 1);
      this.filter.push(this.selectedSubSubSubCategory.category_id);
      console.log(this.filter);
    },
    //-----------------------------------------------
    // Search
    getDocBySeacrh() {
      setTimeout(() => {
        var re = new RegExp(this.searchValue + ".+$", "i");
        this.exams = this.getExams.filter(
          (item) => item.title.search(re) != -1
        );
      }, 800);
    },
    //-----------------------------------------------
    //-----------------------------------------------
    // Filter
    filteredSelectData(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      this.filter.filter((item) => {
        this.exams = this.getExams.filter((element) =>
          element.categories.includes(item)
        );
      });
      closeButton.click();
    },

    removeFiltered() {
      this.exams = this.getExams;
      // this.filter = "";
      this.filter = [];
    },
    //-----------------------------------------------
    ///// Delete Review
    deleteSelectedExam(exam) {
      console.log("deleteExam", exam);
      Swal.fire({
        text: "هل أنت متأكد من حذف هذه الملف؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف الملف بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteExam(exam.exam_id);
        }
      });
    },
    //-----------------------------------------------------//
  },

  async created() {
    if (this.isFirstLoad) await this.fetchExams();
    this.Maincategories = this.getCategories.filter(
      (item) => item.main_category === true
    );
  },
  computed: {
    ...mapGetters("categoriesModule", ["getCategories"]),
    ...mapGetters("examsModule", ["getExams", "isLoading", "isFirstLoad"]),
  },
  mounted() {
    this.exams = this.getExams;
    this.isloading = this.isLoading;
    this.firstLoad = this.isFirstLoad;
    this.categories = this.getCategories;
  },
  watch: {
    getExams() {
      this.exams = this.getExams;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    isFirstLoad() {
      this.firstLoad = this.isFirstLoad;
    },
    getCategories() {
      this.categories = this.getCategories;
    },
  },
};
</script>